import AdminLayout from '@components/organisms/adminLayout/AdminLayout';
import { Heading } from '@components/atoms/heading/Heading';
import React from 'react';
import SEO from '@components/atoms/seo/Seo';

const Statistics = (context) => {
  return (
    <AdminLayout location={context.location}>
      <SEO title="Area" />
      <Heading level="h3" css={{ lineHeight: '1em' }}>
        Statistics
      </Heading>
    </AdminLayout>
  );
};

export default Statistics;
